/* eslint-disable import/extensions,import/no-unresolved,import/no-duplicates,import/no-named-as-default-member */
/**
 * app.js
 *
 * This is the entry file for the application
 */

// Import all the third party stuff
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import FontFaceObserver from 'fontfaceobserver';
import * as Raven from 'raven-js';
import 'babel-polyfill';
import 'sanitize.css/sanitize.css';

// Import app dependencies
import App from 'containers/App';
import LanguageProvider from 'containers/LanguageProvider';

// Import local dependencies
import { appConfig } from './configureApp';
import configureStore from './configureStore';
import Config from './config';
import history from './utils/routeHistory';
import { translationMessages } from './i18n';
import './global-styles';

// conment old code
// import './assets/style.css';

// Import all assets
/* eslint-disable import/no-webpack-loader-syntax */
import '!file-loader?name=[name].[ext]!./images/favicon.ico';
import '!file-loader?name=[name].[ext]!./images/icon-72x72.png';
import '!file-loader?name=[name].[ext]!./images/icon-96x96.png';
import '!file-loader?name=[name].[ext]!./images/icon-120x120.png';
import '!file-loader?name=[name].[ext]!./images/icon-128x128.png';
import '!file-loader?name=[name].[ext]!./images/icon-144x144.png';
import '!file-loader?name=[name].[ext]!./images/icon-152x152.png';
import '!file-loader?name=[name].[ext]!./images/icon-167x167.png';
import '!file-loader?name=[name].[ext]!./images/icon-180x180.png';
import '!file-loader?name=[name].[ext]!./images/icon-192x192.png';
import '!file-loader?name=[name].[ext]!./images/icon-384x384.png';
import '!file-loader?name=[name].[ext]!./images/icon-512x512.png';
import '!file-loader?name=[name].[ext]!./images/real-logo.png';
import '!file-loader?name=[name].[ext]!./images/woolworths-logo.png';
import '!file-loader?name=[name].[ext]!./images/hollard-logo.png';
import '!file-loader?name=[name].[ext]!./images/asia-logo.png';
import '!file-loader?name=[name].[ext]!./images/kogan-logo.png';
import '!file-loader?name=[name].[ext]!./images/vodafone-logo.png';
import '!file-loader?name=[name].[ext]!./images/Trip-Cancellation-gray.png';
import '!file-loader?name=[name].[ext]!./images/Trip-Distruption-gray.png';
import '!file-loader?name=[name].[ext]!./images/Trip-Cancellation-New-h.png';
import '!file-loader?name=[name].[ext]!./images/Trip-Cancellation-gray.png';
import '!file-loader?name=[name].[ext]!./images/demo-appsure-logo.jpg';
import '!file-loader?name=[name].[ext]!./images/Trawick_Logo.jpg';
import '!file-loader?name=[name].[ext]!./images/cbp-logo.png';
import '!file-loader?name=[name].[ext]!./images/cbp-logo-surego.png';
import '!file-loader?name=[name].[ext]!./images/Medical-gray.png';
import '!file-loader?name=[name].[ext]!./images/Luggage-gray.png';
import '!file-loader?name=[name].[ext]!./images/Other-gray.png';
import '!file-loader?name=[name].[ext]!./images/Other-gray-h.png';
import '!file-loader?name=[name].[ext]!./images/Trip-Cancellation-New-h.png';
import '!file-loader?name=[name].[ext]!./images/Medical-gray-h.png';
import '!file-loader?name=[name].[ext]!./images/Trip-Cancellation-New-gray-h.png';
import '!file-loader?name=[name].[ext]!./images/Rental-Vehicle.png';
import '!file-loader?name=[name].[ext]!./images/chat_128.png';
import '!file-loader?name=[name].[ext]!./images/file_attachment_128.png';
import '!file-loader?name=[name].[ext]!./images/outcome_128.png';
import '!file-loader?name=[name].[ext]!./assets/checkExpiredTimeWorker.js';
import '!file-loader?name=[name].[ext]!./manifest.json';
import '!file-loader?name=[name].[ext]!./web.config';
import 'file-loader?name=[name].[ext]!./.htaccess'; // eslint-disable-line import/extensions
import '!file-loader?name=[name].[ext]!./images/world2cover-logo.png';
import '!file-loader?name=[name].[ext]!./images/Personal-Accident-gray.png';
import '!file-loader?name=[name].[ext]!./images/Cash-and-Bank-Cards.png';
import '!file-loader?name=[name].[ext]!./images/scti-logo.png';
import '!file-loader?name=[name].[ext]!./images/TuGo-Logo.jpg';
/* eslint-enable import/no-webpack-loader-syntax */

// Runtime dependencies
const runtime = require('offline-plugin/runtime');

// Conditionally import environment-specific styles
const loadEnvironmentStyles = async () => {
  if (appConfig.reactAppEnv === 'trawick') {
    await import('./assets/styles.trawick.css');
  } else if (appConfig.reactAppEnv === 'scti') {
    await import('./assets/styles.scti.css');
  }else if (appConfig.reactAppEnv === 'tugo') {
    await import('./assets/styles.tugo.css');
  }else {
    await import('./assets/style.css');
  }
};

// Load environment-specific styles
loadEnvironmentStyles();

// Observe loading of fonts
const openSansObserver = new FontFaceObserver(appConfig.fontType, {});

// When Open Sans is loaded, add a font-family using Open Sans to the body
openSansObserver.load().then(() => {
  document.body.classList.add('fontLoaded');
}, () => {
  document.body.classList.remove('fontLoaded');
});

// Create redux store with history
const initialState = {};
const store = configureStore(initialState, history);
const MOUNT_NODE = document.getElementById('app');

const render = (messages) => {
  ReactDOM.render(
    <Provider store={store}>
      <LanguageProvider messages={messages}>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </LanguageProvider>
    </Provider>,
    MOUNT_NODE
  );
};

// Sentry configuration
if (!!VARS.SENTRY_CDS) {
  Raven
    .config(VARS.SENTRY_CDS, {
      release: Config.version,
      environment: process.env.NODE_ENV,
      autoBreadcrumbs: {
        xhr: false,      // XMLHttpRequest
        console: false,  // console logging
        dom: true,       // DOM interactions, i.e. clicks/typing
        location: true, // url changes, including pushState/popState
        sentry: true,     // sentry events
      },
    })
    .install();
}

if (module.hot) {
  // Hot reloadable React components and translation json files
  // modules.hot.accept does not accept dynamic dependencies,
  // have to be constants at compile-time
  module.hot.accept(['./i18n', 'containers/App'], () => {
    ReactDOM.unmountComponentAtNode(MOUNT_NODE);
    render(translationMessages);
  });
}

// Chunked polyfill for browsers without Intl support
if (!window.Intl) {
  (new Promise((resolve) => {
    resolve(import('intl'));
  }))
    .then(() => Promise.all([
      import('intl/locale-data/jsonp/en.js'),
      import('intl/locale-data/jsonp/vi.js'),
      import('intl/locale-data/jsonp/fr.js'),
      import('intl/locale-data/jsonp/es.js'),
    ]))
    .then(() => render(translationMessages))
    .catch((err) => {
      throw err;
    });
} else {
  render(translationMessages);
}

// Install ServiceWorker and AppCache in the end since
// it's not most important operation and if main code fails,
// we do not want it installed
if (process.env.NODE_ENV === 'production') {
  runtime.install({
    onUpdateReady: () => {
      // Tells to new SW to take control immediately
      runtime.applyUpdate();
    },
    onUpdated: () => {
      // Reload the webpage to load into the new version
      window.location.reload();
    },
  }); // eslint-disable-line global-require
}


// WEBPACK FOOTER //
// ./app/app.js